export const caretUpSvg = (
  <svg
    data-testid="ock-caretUpSvg"
    role="img"
    aria-label="ock-caretUpSvg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.05329 10.9866L7.99996 6.03997L12.9466 10.9866L14.1266 9.80663L7.99996 3.67997L1.87329 9.80663L3.05329 10.9866Z"
      className="fill-ock-foreground"
    />
  </svg>
);
